module.exports = __webpack_public_path__ + "static/media/Plan_Loader.7b4bb14a.gif";